export default __webpack_public_path__ + "static/media/google-logo.0d5c1475.png";